import React from 'react';

const CommonDataContext = React.createContext();

export const CommonDataContextProvider = CommonDataContext.Provider;

export default CommonDataContext;
